import { Button } from 'components/Button/Button';
import { Stack } from 'components/Stack/Stack';
import type { CmsApiCategory } from 'modules/cms/api/types/CmsApiCategory';
import { spacing } from 'theme/theme';

type Props = {
  homePageUrl: string | undefined;
  categories: CmsApiCategory[];
};

export function CmsCategories({ homePageUrl, categories }: Props) {
  // Hide parent categories with children present.
  const filteredCategories = categories.filter(
    (category) =>
      category.parentId !== null ||
      categories.every(
        (potentialChild) => potentialChild.parentId !== category.id,
      ),
  );
  return (
    <Stack direction="row" data-qa-id="categories" spacing={spacing[6]}>
      {filteredCategories.map((category) => (
        <Button
          size="small"
          variant="secondary-green"
          key={category.slug}
          type="link"
          data-qa-id="category-link"
          href={
            homePageUrl ? `/${homePageUrl}?categories=${category.slug}&pq=` : ''
          }
        >
          {category.name.toUpperCase()}
        </Button>
      ))}
    </Stack>
  );
}
